export interface IProduct {
  id: string
  name: string
  featuredImage: string
  images: string[]
  price: number
  compareAtPrice?: number
  tags?: string[]
  available: boolean
  sku: string
  handle: string
  quantity: number
  variantId: number
  variants: IProductVariant[]
  encodedVariantId: string
  collections?: string[]
  description?: string
  barcode?: string
  weight: string
  metafield_cuisine: string
  metafield_preference: string[]
  metafield_protein: string
  metafield_category: string[]
}

export interface IProductVariant {
  id: number
  title: string
  price: number
  compareAtPrice?: number
  available: boolean
  sku: string
  barcode?: string
  weight: string
}
